export default function getDateState() {
  const currentDate = new Date();
  currentDate.setMinutes(Math.round(currentDate.getMinutes() / 5) * 5);
  currentDate.setSeconds(0);
  currentDate.setMilliseconds(0);

  return currentDate;
}
